/**
 * Merge two arrays while keeping the first occurrence of each key.
 *
 * This helper only handles collection merging; it does not mutate either
 * input array and does not change the shape of the stored items.
 */
export function mergeUniqueBy(previous = [], incoming = [], getKey) {
  const result = [...previous];
  const seen = new Set(previous.map(getKey));

  incoming.forEach((item) => {
    const key = getKey(item);
    if (seen.has(key)) return;
    seen.add(key);
    result.push(item);
  });

  return result;
}
